import CadModelDisplay from "../Displays/CadModelDisplay"
import OrderDetails from "./OrderDetails"
import { metaobject } from "../../Helpers/WindowHelpers"
import { useFormikContext } from "formik"
import parse from 'html-react-parser';

interface Step6Interface {

}

const Step6 = ({ }: Step6Interface) => {
    const context = useFormikContext<any>();
    return (
        <>
            <div className="d--flex sm--flex-column">
                <div className="d--flex flex-column gap-16 width--100">
                    {!context.values?.customShape &&
                        <>
                            <div id="cad_image">
                                <CadModelDisplay></CadModelDisplay>
                            </div>
                            <div className="attestation-text">{parse(metaobject.text.cad_attestation ?? '')}</div>
                        </>
                    }
                    <OrderDetails />
                </div>
            </div>
        </>
    )
}
export default Step6